const config = {
    apiKey: "AIzaSyArD834obh-sPqIuh4oCYrKW2-Mf_CbEKM",
    authDomain: "pentumas-2f139.firebaseapp.com",
    databaseURL: "https://pentumas-2f139.firebaseio.com",
    projectId: "pentumas-2f139",
    storageBucket: "pentumas-2f139.appspot.com",
    messagingSenderId: "807986332019"
};

const devConfig = {
    apiKey: "AIzaSyBh36yITaxoI3x7JVBYbB_6sAYOsrrdiMc",
    authDomain: "pentumas-dev.firebaseapp.com",
    databaseURL: "https://pentumas-dev.firebaseio.com",
    projectId: "pentumas-dev",
    storageBucket: "pentumas-dev.appspot.com",
    messagingSenderId: "119657497899",
    appId: "1:119657497899:web:44e295e3775a16db"
}

const isDev = window.location.href.indexOf('pentumas.local') >= 0;

firebase.initializeApp(isDev ? devConfig : config);

const database = firebase.database();
const auth = firebase.auth();
const storage = firebase.storage();
